import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
} from './components/base_components';
import { withRouter } from 'inferno-router';
import { BusyComponent, BusyOverlay } from './components/busy_component';
import TextButton from './components/buttons/text_button';

import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  logoutScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '1em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  line: {
    alignSelf: 'stretch',
    height: '1px',
    backgroundColor: 'black',
  },
  headerText: {
    marginTop: '1em',
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  list: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  add: {
    marginTop: '1em',
  },
  input: {
    marginTop: '1em',
    paddingLeft: '0.5em',
    width: '20em',
    height: '2em',
    backgroundColor: '#eee',
    borderRadius: '0.2em',
  },
  button: {
    marginTop: '1em',
    height: '2em',
  },
});

type Props = {
  history: any;
};
type State = {};

class LogoutScreen extends BusyComponent<Props, State> {
  state = {};

  componentDidMount() {
    this._onLogoutPress();
  }

  _onLogoutPress = () => {
    if (this.setBusy()) {
      UserStore.logout((err) => {
        this.clearBusy();
        if (err) {
          window.alert('Logout failed');
        } else {
          this.props.history.replace('/');
        }
      });
    }
  };

  render() {
    return (
      <View style={styles.logoutScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <Text style={styles.headerText}>MONP ABT</Text>
          <Line />
          <Text style={styles.headerText}>Logout</Text>
          <TextButton
            style={styles.button}
            text='Logout'
            onPress={this._onLogoutPress}
          />
        </ScrollView>
        <BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}
export default withRouter(LogoutScreen);

function Line() {
  return <View style={styles.line} />;
}
